/**
 * Taken, CommonJS-ified, and heavily modified from:
 * https://github.com/flyingsparx/NodeDirectUploader
 * https://raw.githubusercontent.com/odysseyscience/react-s3-uploader/master/s3upload.js
 */

declare const XDomainRequest: $TSFixMe;
declare type XDomainRequest = $TSFixMe;

export default class S3Upload {
  options = {
    signingUrl: '/sign-s3',
    onFinishS3Put(signResult: $TSFixMe) {
      //   console.log('base.onFinishS3Put()', signResult.publicUrl);
    },
    onProgress(percent: $TSFixMe, status: $TSFixMe) {
      //   console.log('base.onProgress()', percent, status);
    },
    onError(status: $TSFixMe) {
      //   console.log('base.onError()', status);
    },
  };

  constructor(options = {}) {
    Object.assign(this.options, options);
  }

  handleFileSelect = (fileElement: $TSFixMe) => {
    this.options.onProgress(0, 'Upload started.');
    const { files } = fileElement;
    const result: $TSFixMe = [];
    for (let i = 0; i < files.length; i += 1) {
      const f = files[i];
      // I don't want to change this behavior, but it looks buggy
      result.push(this.uploadFile(f));
    }
    return result;
  };

  createCORSRequest = (method: $TSFixMe, url: $TSFixMe) => {
    let xhr: XMLHttpRequest | XDomainRequest | null = new XMLHttpRequest();

    if (xhr.withCredentials != null) {
      xhr.open(method, url, true);
    } else if (typeof XDomainRequest !== 'undefined') {
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else {
      xhr = null;
    }
    return xhr;
  };

  executeOnSignedUrl = async (file: $TSFixMe, callback: $TSFixMe) => {
    const xhr = new XMLHttpRequest();
    const fileName = file.name.replace(/\s+/g, '_');

    xhr.open('POST', this.options.signingUrl + '&fileName=' + encodeURIComponent(fileName), true);
    xhr.setRequestHeader('X-Coursera-Source', 'Internal');
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let result;
        try {
          result = JSON.parse(xhr.responseText);
        } catch {
          this.options.onError('Invalid signing server response JSON: ' + xhr.responseText);
          return false;
        }
        return callback(result);
      } else if (xhr.readyState === 4 && xhr.status !== 200) {
        const json = JSON.parse(xhr.responseText);
        return this.options.onError(json.errorCode);
      }
      return false;
    };
    return xhr.send();
  };

  uploadToS3 = (file: $TSFixMe, signResult: $TSFixMe) => {
    const xhr = this.createCORSRequest('PUT', signResult.url);
    if (!xhr) {
      this.options.onError('CORS not supported');
    } else {
      xhr.onload = () => {
        if (xhr.status === 200) {
          this.options.onProgress(100, 'Upload completed.');
          return this.options.onFinishS3Put(signResult);
        } else {
          return this.options.onError('Upload error: ' + xhr.status);
        }
      };
      xhr.onerror = () => {
        return this.options.onError('XHR error.');
      };
      xhr.upload.onprogress = (e: $TSFixMe) => {
        let percentLoaded;
        if (e.lengthComputable) {
          percentLoaded = Math.round((e.loaded / e.total) * 100);
          this.options.onProgress(percentLoaded, percentLoaded === 100 ? 'Finalizing.' : 'Uploading.');
        }
      };
    }
    xhr.setRequestHeader('Content-Type', file.type);
    return xhr.send(file);
  };

  uploadFile = (file: $TSFixMe) => {
    return this.executeOnSignedUrl(file, (signResult: $TSFixMe) => {
      return this.uploadToS3(file, signResult);
    });
  };
}
